import { INSTALLATION_SCODES, INSTALLATION_TPMS } from 'utils/constantValues';

export function isInstallation(partNumber: string) {
  return INSTALLATION_SCODES.includes(partNumber) || partNumber === INSTALLATION_TPMS;
}

export function isTireInstallation(partNumber: string) {
  return INSTALLATION_SCODES.includes(partNumber);
}
